import { Offcanvas, Row } from 'react-bootstrap';
import React from 'react';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import { FormProvider, useForm } from 'react-hook-form';
import { AddEntityDrawerProps } from './EntityListProps';
import { useCreateIncidentTactic } from './hooks/incidentTacticHooks';
import DrawerWrapper, { DrawerFooter } from './DrawerWrapper';
import FormTextField from './formFields/FormTextField';
import FormTextAreaField from './formFields/FormTextAreaField';
import { useCreateTactic } from './hooks/tacticHooks';
import { INCIDENT } from './ICSConstants';
import { TacticBase } from '../../types/iapBaseTypes';

type FormFields = TacticBase;

const TacticAddDrawer: React.FC<AddEntityDrawerProps> = ({ toggle, scope }) => {
  const form = useForm<FormFields>({
    mode: 'onChange',
  });
  const { handleSubmit, watch } = form;

  const watchedName = watch('name');

  const incidentMutation = useCreateIncidentTactic();
  const organizationMutation = useCreateTactic();

  const onNewTacticDataSubmit = async (formData: FormFields) => {
    const payload = {
      name: formData.name,
      description: formData.description,
      archived: false,
    };

    if (scope === INCIDENT) {
      await incidentMutation.mutateAsync(payload);
    } else {
      await organizationMutation.mutateAsync(payload);
    }
    toggle();
  };

  return (
    <DrawerWrapper toggle={toggle} title="Add Tactic">
      <FormProvider {...form}>
        <form
          onSubmit={handleSubmit(onNewTacticDataSubmit)}
          className="d-flex flex-column justify-content-between flex-grow-1"
        >
          <Offcanvas.Body>
            <Row>
              <FormTextField
                title="Name"
                fieldName="name"
                rules={{
                  required: { value: true, message: 'This field is required' },
                  maxLength: {
                    value: 300,
                    message: 'The maximum length is 300 characters',
                  },
                }}
                variant="half"
              />
            </Row>
            <Row>
              <FormTextAreaField
                title="Description"
                fieldName="description"
                rules={{
                  maxLength: {
                    value: 300,
                    message: 'The maximum length is 300 characters',
                  },
                }}
                variant="full"
              />
            </Row>
          </Offcanvas.Body>
          <DrawerFooter>
            <div className="button-group">
              <StylishNewButton
                className="button--secondary button--reverse"
                type="button"
                onClick={toggle}
              >
                Close
              </StylishNewButton>
              <StylishNewButton
                className="button--primary"
                type="submit"
                disabled={
                  !watchedName ||
                  (scope === INCIDENT
                    ? incidentMutation.isPending
                    : organizationMutation.isPending)
                }
              >
                Save
              </StylishNewButton>
            </div>
          </DrawerFooter>
        </form>
      </FormProvider>
    </DrawerWrapper>
  );
};

export default TacticAddDrawer;
